import React, { useEffect } from "react";
import { AlertTriangle } from "lucide-react";
import { InlineLoadSkeleton } from "../common/InlineLoadSkeleton";
import { Button } from "./button";
import Modal from "./Modal";
import { useModal } from "../../context/ModalContext";

const ConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  /** When set, replaces the default single-paragraph message (for multi-line / rich copy) */
  children,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmVariant = "danger",
  loading = false,
}) => {
  const { incrementModalCount, decrementModalCount } = useModal();

  // Auto-sync modal state with global context
  useEffect(() => {
    if (isOpen) {
      incrementModalCount();
      return () => {
        decrementModalCount();
      };
    }
  }, [isOpen, incrementModalCount, decrementModalCount]);

  const handleConfirm = async () => {
    if (onConfirm) {
      await onConfirm();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="sm"
      modalType={<div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
        <AlertTriangle className="w-6 h-6 text-red-600" />
      </div>}
    >
      <div className="space-y-4">


        {/* Message */}
        {children ? (
          <div className="text-text-primary text-sm leading-relaxed">
            {children}
          </div>
        ) : (
          <div className="text-center">
            <p className="text-text-primary">{message}</p>
          </div>
        )}

        {/* Actions */}
        <div className="flex space-x-3 pt-4">
          <Button
            type="button"
            onClick={onClose}
            disabled={loading}
            variant="outline"
            className="flex-1"
          >
            {cancelText}
          </Button>
          <Button
            type="button"
            onClick={handleConfirm}
            disabled={loading}
            variant={confirmVariant === "danger" ? "destructive" : "default"}
            className="flex-1"
          >
            {loading ? (
              <span className="inline-flex items-center gap-2">
                <InlineLoadSkeleton className="h-4 w-4" />
                {confirmText}
              </span>
            ) : (
              <span>{confirmText}</span>
            )}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmDialog;
